// extracted by mini-css-extract-plugin
export default {"wrapper":"StatusFilter_wrapper__23oPu","checkboxContainer":"StatusFilter_checkboxContainer__2nh0B","marginRight":"StatusFilter_marginRight__1GWlf"};